<div class="page-gallery" *ngIf="selected_document">
  <div class="gallery-header">
    <div class="header-title-section">
      <h2 
        *ngIf="!isEditingTitle" 
        class="document-title"
        (click)="startEditingTitle()"
        [title]="'Click to edit'">
        {{ selected_document.display_name }}
        <svg class="edit-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
        </svg>
      </h2>
      <div *ngIf="isEditingTitle" class="title-edit-container">
        <input 
          #titleInput
          type="text" 
          class="title-input"
          [(ngModel)]="editedTitle"
          (keydown.enter)="saveTitle()"
          (keydown.escape)="cancelEditTitle()"
          (blur)="saveTitle()"
          [attr.data-testid]="'input-document-title'">
        <button 
          class="save-title-btn" 
          (click)="saveTitle()"
          [attr.data-testid]="'btn-save-title'">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20,6 9,17 4,12"></polyline>
          </svg>
          Save
        </button>
        <button 
          class="cancel-title-btn" 
          (click)="cancelEditTitle()"
          [attr.data-testid]="'btn-cancel-title'">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
          Cancel
        </button>
      </div>
    </div>
    <p class="page-count">{{ selected_document.page_count }} pages • Drag to reorder, click to preview, or move to another file</p>
  </div>

  <div class="gallery-content">
    <div 
      class="page-grid"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="selected_document.pages"
      (cdkDropListDropped)="onPageDrop($event)">
      <div 
        *ngFor="let page of selected_document.pages; let i = index" 
        class="page-card"
        [class.is-moving]="isPageMoving(page.page_id)"
        cdkDrag
        [attr.data-testid]="'page-card-' + (i + 1)">
        
        <!-- Loading overlay for pages being moved -->
        <div class="page-loading-overlay" *ngIf="isPageMoving(page.page_id)">
          <div class="loading-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="spinner">
              <line x1="12" y1="2" x2="12" y2="6"></line>
              <line x1="12" y1="18" x2="12" y2="22"></line>
              <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
              <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
              <line x1="2" y1="12" x2="6" y2="12"></line>
              <line x1="18" y1="12" x2="22" y2="12"></line>
              <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
              <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
          </div>
        </div>
        
        <div class="page-thumbnail" (click)="previewPage(page)">
          <!-- Show PDF in iframe if URL exists -->
          <iframe 
            *ngIf="page.preview_url && isPdfUrl(page.preview_url)" 
            [src]="sanitizeUrl(page.preview_url)" 
            [title]="'Page ' + (i + 1)"
            class="pdf-iframe">
          </iframe>
          
          <!-- Show image if URL exists but not PDF -->
          <img 
            *ngIf="page.preview_url && !isPdfUrl(page.preview_url)" 
            [src]="page.preview_url" 
            [alt]="'Page ' + (i + 1)"
            (error)="onImageError($event)">
          
          <!-- Show placeholder if no URL -->
          <div *ngIf="!page.preview_url" class="pdf-placeholder">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <text x="12" y="16" font-size="6" text-anchor="middle" fill="currentColor">PDF</text>
            </svg>
            <p>PDF Page {{ i + 1 }}</p>
          </div>
          
          <div class="page-label">
            <span class="page-number">Page {{ page.page_number }}</span>
          </div>
        </div>
        
        <div class="page-actions">
          <select class="move-select" [value]="selected_document?.doc_id" (change)="onMovePageToFile($event, page.page_id)">
            <option *ngIf="selected_document" [value]="selected_document.doc_id">
              → {{ selected_document.display_name }}
            </option>
            <option *ngFor="let doc of getOtherDocuments()" [value]="doc.doc_id">
              → {{ doc.display_name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Approve button at bottom -->
  <div class="gallery-footer" *ngIf="!selected_document.is_approved && selected_document.page_count > 0">
    <button 
      class="btn btn-primary approve-file-btn" 
      data-testid="btn-approve-file"
      (click)="onApproveButtonClick()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20,6 9,17 4,12"></polyline>
      </svg>
      Approve & Lock {{ selected_document.display_name }}
    </button>
  </div>

  <!-- Empty file warning -->
  <div class="gallery-footer empty-file-warning" *ngIf="!selected_document.is_approved && selected_document.page_count === 0">
    <div class="warning-message">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
      <span>This file is empty</span>
      <p>Add pages to this file before approving</p>
    </div>
  </div>
  
  <!-- Approved state -->
  <div class="gallery-footer approved" *ngIf="selected_document.is_approved">
    <div class="approved-message">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="m9 12 2 2 4-4"></path>
        </svg>
        File Approved & Locked
      </span>
      <p>This file has been finalized</p>
    </div>
    <button 
      *ngIf="fileStatus === MultipartDocumentStatus.SEPARATION_REVIEW"
      class="unapprove-btn" 
      data-testid="btn-unapprove-file"
      (click)="onUnapproveDocument()">
      Unapprove
    </button>
  </div>
</div>

<div class="empty-state" *ngIf="!selected_document">
  <p>Select a file to review</p>
</div>
